export const types = {
    LOADING_SHOW: "LOADING_SHOW",
    LOADING_HIDE: "LOADING_HIDE"
};

export const actions = {
    showLoading: (payload = {}) => ({
        type: types.LOADING_SHOW,
        payload: payload
    }),
    hideLoading: (payload = {}) => ({
        type: types.LOADING_HIDE,
        payload
    })
}
